module.exports = __webpack_public_path__ + "static/media/CustomLink.61475d22.png";